import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Button, Grid, Paper } from '@mui/material';
import UserList from './UserList';
import { Link } from 'react-router-dom';
import AdminMenus from '../AdminMenus';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Grid>{children}</Grid>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const AllUsersList = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="container-xxl">
      <div className="container">
        <div className="mb-3">
          <AdminMenus buttonName='Add User' pageName='createNewUser' />
        </div>
        <div className="row dataTable">
          <Box sx={{ width: '100%' }}>
            <Paper sx={{ width: '100%', mb: 2 }}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                  <Tab label="All" {...a11yProps(0)} />
                  <Tab label="Registered" {...a11yProps(1)} />
                  <Tab label="Indiscussion" {...a11yProps(2)} />
                  <Tab label="Joined" {...a11yProps(3)} />
                  <Tab label="Rejected" {...a11yProps(4)} />
                </Tabs>
              </Box>
              <TabPanel value={value} index={0}>
                <UserList status='all' />
              </TabPanel>
              <TabPanel value={value} index={1}>
                <UserList status='Registered' />
              </TabPanel>
              <TabPanel value={value} index={2}>
                <UserList status='Indiscussion' />
              </TabPanel>
              <TabPanel value={value} index={3}>
                <UserList status='Joined' />
              </TabPanel>
              <TabPanel value={value} index={4}>
                <UserList status='Rejected' />
              </TabPanel>
            </Paper>
          </Box>
        </div>
      </div>
    </div>
  );
}

export default AllUsersList;
